import { render } from "./HeroiconsOutlineReceiptTax.vue?vue&type=template&id=5d606d62"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineReceiptTax.vue"]])

export default __exports__